var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    transform: "translate(4771.248 366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    className: "st0",
    d: "M-4769.5-362.4l0.6,7.1c0.1,0.5,0.5,0.9,1,0.9h5.4c0.5,0,0.9-0.4,1-0.9l0.6-7.1H-4769.5z  M-4766.9-355.6c-0.2,0-0.3-0.1-0.3-0.3l-0.3-5.4c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3l0,0l0.3,5.4 C-4766.6-355.8-4766.7-355.7-4766.9-355.6L-4766.9-355.6z M-4764.9-356c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3l0,0v-5.4 c0-0.2,0.2-0.3,0.3-0.3s0.3,0.2,0.3,0.3l0,0V-356z M-4762.9-361.4l-0.3,5.4c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3 l0.3-5.4c0-0.2,0.2-0.3,0.3-0.3C-4763.1-361.7-4762.9-361.5-4762.9-361.4L-4762.9-361.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    transform: "translate(4770 360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    className: "st0",
    d: "M-4759.7-358.4h-2v-0.3c0-0.6-0.4-1-1-1h-2.7c-0.6,0-1,0.4-1,1v0.3h-2c-0.4,0-0.7,0.3-0.7,0.7 s0.3,0.7,0.7,0.7h8.6c0.4,0,0.7-0.3,0.7-0.7C-4759-358.1-4759.3-358.4-4759.7-358.4z M-4762.3-358.4h-3.3v-0.3 c0-0.2,0.2-0.3,0.3-0.3h2.7c0.2,0,0.3,0.2,0.3,0.3V-358.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBlue);
export default __webpack_public_path__ + "static/media/delete-icon-blue.acb0dd6597119ebbf4a51a891c775601.svg";
export { ForwardRef as ReactComponent };